import { render } from "./Promotions.vue?vue&type=template&id=38892728"
import script from "./Promotions.vue?vue&type=script&lang=js"
export * from "./Promotions.vue?vue&type=script&lang=js"

import "./Promotions.vue?vue&type=style&index=0&id=38892728&lang=scss"

import exportComponent from "/Volumes/Samsung_T5/Work/Projects/my_projects/profiguide/profiguide/src/profiguide/static/web_plugin/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__